"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Phone = function Phone(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-761.000000, -166.000000)",
    fillRule: "nonzero",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(761.000000, 166.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5964729,14.2371326 L14.8166536,11.4507038 C14.2629651,10.8979894 13.3460462,10.9147823 12.7730689,11.4892653 L11.372584,12.8926124 C11.2841035,12.8437368 11.1925202,12.7926843 11.096231,12.738522 C10.2118395,12.2473816 9.00139899,11.5742145 7.72766207,10.2966586 C6.45015013,9.01640751 5.77788429,7.80135849 5.28635454,6.91439291 C5.23448665,6.82042525 5.18479069,6.72982653 5.13571528,6.64378885 L6.07564635,5.70312747 L6.53775154,5.23940509 C7.111608,4.66409288 7.12743211,3.74535555 6.57503644,3.19103446 L3.7952172,0.404294661 C3.24282153,-0.149248982 2.32548894,-0.132456085 1.75163248,0.442856128 L0.968184214,1.23258876 L0.989593296,1.25389086 C0.726892491,1.58985246 0.507371839,1.97733301 0.344011241,2.3951859 C0.193423693,2.79292877 0.0996684649,3.17247935 0.0567985896,3.55280737 C-0.310258558,6.60268772 1.08029747,9.39004947 4.85408761,13.1724422 C10.0706119,18.4004235 14.2744454,18.0054794 14.455802,17.9861987 C14.850784,17.938878 15.2293214,17.8442884 15.6140126,17.6945517 C16.027301,17.5327387 16.413647,17.3130316 16.7486422,17.0503057 L16.7657591,17.0655437 L17.5594465,16.2865917 C18.1321136,15.7113831 18.14861,14.7923348 17.5964729,14.2371326 Z"
  })))));
};
/* eslint-enable */
var _default = Phone;
exports["default"] = _default;